import {Backdrop, Box, Grid2, CircularProgress, Stack, Typography} from '@mui/material'
import { useEffect, useState, useContext } from 'react';
import { Context } from "../App";
import ServiceCard from '../components/ui/ServiceCard';
import { AccessList, SuperAdmAccessList } from '../conf';
import Masonry from 'react-masonry-css';
import AppLayout from '../components/layout/AppLayout';

function Home() {
  const { setIsConnected } = useContext(Context)
  const [loading, setLoading] = useState(false);
  const user = JSON.parse(sessionStorage.getItem('user'))

  useEffect(()=> {
    if (!user || user.role === 'user') {
      sessionStorage.clear();
      setIsConnected(false);
    }
  }, [user])


  return (
    <AppLayout>

      <Masonry
      breakpointCols={{ default: 3,  1080: 2, 700: 1}}
      className="my-masonry-grid"
      columnClassName="my-masonry-grid_column"
      style={{ padding: 32,}}
      >
        {(user.role === 'admin' ? AccessList.filter(item => user.access.includes(item.label)) : [...AccessList, ...SuperAdmAccessList])
        .sort((a, b) => a.label.localeCompare(b.label))
          .map((item, index) => (
            <Grid2 size={{ xs: 12, sm: 6, md: 6, lg: 4 }} key={index}>
              <ServiceCard item={item} />
            </Grid2>
          ))}
      </Masonry>

      <Backdrop open={loading}><CircularProgress/></Backdrop>
    </AppLayout>
  );
}

export default Home;
